import {
    initialState,
    Actions,
    State,
    DOWNLOAD_CUSTOMER,
    DOWNLOAD_CUSTOMER_SUCCESS,
    DOWNLOAD_CUSTOMER_ERROR,
    RESET_DOWNLOAD_CUSTOMER,
} from '../../types/customer/download-customer'

const reducers = (state = initialState, action: Actions): State => {
    switch (action.type) {
        case DOWNLOAD_CUSTOMER:
            return {
                ...state,
                data: null,
                states: {
                    loading: true,
                    error: false,
                    success: false,
                },
            }
        case DOWNLOAD_CUSTOMER_SUCCESS:
            return {
                ...state,
                data: action.payload,
                states: {
                    loading: false,
                    error: false,
                    success: true,
                },
            }
        case DOWNLOAD_CUSTOMER_ERROR:
            return {
                ...state,
                data: null,
                states: {
                    loading: false,
                    error: action.payload,
                    success: false,
                },
            }
        case RESET_DOWNLOAD_CUSTOMER:
            return initialState
        default:
            return state
    }
}

export default reducers